export default __webpack_public_path__ + "static/media/science.f533a682.png";